__turbopack_context__.v({
  "button": "style-module-scss-module__UcQ_YW__button",
  "card-wrapper": "style-module-scss-module__UcQ_YW__card-wrapper",
  "mobile-card-wrapper": "style-module-scss-module__UcQ_YW__mobile-card-wrapper",
});
